import "@/assets/styles/common.less";
import "./enter.less";
import "reset.css";

$.extend({
  message: function (j) {
    var e = {
      message: " 操作成功",
      time: "2000",
      type: "success",
      showClose: false,
      autoClose: true,
      onClose: function () {}
    };
    if (typeof j === "string") {
      e.message = j;
    }
    if (typeof j === "object") {
      e = $.extend({}, e, j);
    }
    var c = e.showClose ? "<a class=\"c-message--close\">×</a>" : "";
    var i = "<div class=\"c-message messageFadeInDown\"><div class=\"c-message--main\"><i class=\" c-message--icon c-message--" + e.type + "\"></i>" + c + "<div class=\"c-message--tip\">" + e.message + "</div></div></div>";

    var f = $("body");
    var g = $(i);
    var d;
    var a, b;
    a = function () {
      g.addClass("messageFadeOutUp");
      g.one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function () {
        b();
      });
    }
    ;
    b = function () {
      g.remove();
      e.onClose(e);
      clearTimeout(d);
    }
    ;
    $(".c-message").remove();
    f.append(g);
    g.css({
      "margin-left": "-" + g.width() / 2 + "px"
    });
    g.one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function () {
      g.removeClass("messageFadeInDown");
    });
    f.on("click", ".c-message--close", function (k) {
      a();
    });
    if (e.autoClose) {
      d = setTimeout(function () {
        a();
      }, e.time);
    }
  }
});

window.loadingFlag = false;
$(function () {
  new WOW().init();

  $(window).scroll(function () {
    const s = $(document).scrollTop();
    if (s > 50) {
      $("#PCNav").addClass("show");
    } else {
      $("#PCNav").removeClass("show");
    }
  });

  $("#caseBox .case-item-box").on("click", function () {
    $("#caseBox .case-item-box").removeClass("expand-item");
    $(this).addClass("expand-item");
  });

  $("#menuBtn").on("click", function () {
    $("#mobileNavExpand").addClass("expand-state");
  });

  $("#closeMenuBtn").on("click", function () {
    $("#mobileNavExpand").removeClass("expand-state");
  });

  $(".nav-click-box .click-item").on("click", function () {
    let str = "#" + $(this).data("id") + "Title";
    $("html,body").animate({ scrollTop: $(str).offset().top - 70 }, 800);
    $("#mobileNavExpand").removeClass("expand-state");
  });

  $("body").on("click", function (e) {
    let _this = e.target;
    let res = $(_this).parents("#mobileNavExpand");
    let id = $(_this).attr("id");

    if (!res.length && id !== "menuBtn" && id !== "mobileNavExpand") $("#mobileNavExpand").removeClass("expand-state");
  });

  $("#submitBtn").on("click", function () {
    if (window.loadingFlag) return false;

    let nameInput = $("#nameInput");
    let emailInput = $("#emailInput");
    let nameText = $.trim(nameInput.val());
    let emailText = $.trim(emailInput.val());
    let reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;

    if (!nameText.length) {
      return $.message({
        message: "请输入姓名",
        type: "error"
      });
    }
    if (!emailText.length) {
      return $.message({
        message: "请输入邮箱",
        type: "error"
      });
    }

    if (!reg.test(emailText)) {
      return $.message({
        message: "邮箱格式不正确",
        type: "error"
      });
    }

    let sendData = {
      name: nameText,
      email: emailText
    };

    $("#submitBtn").addClass("loading-state").attr("disabled", true);
    $.ajax({
      type: "get",
      url: "/api/email/add",
      dataType: "json",
      data: sendData,
      success: function (res) {
        $("#submitBtn").removeClass("loading-state").removeAttr("disabled");
        if (!res.success) {
          return $.message({
            message: res.message,
            type: "error"
          });
        }

        $("#formBox").addClass("submitted");
        $.message("提交成功");
      }
    });
  });
});
